import { render } from "./AuditionBoard.vue?vue&type=template&id=26453cf5"
import script from "./AuditionBoard.vue?vue&type=script&lang=js"
export * from "./AuditionBoard.vue?vue&type=script&lang=js"

import "./AuditionBoard.vue?vue&type=style&index=0&id=26453cf5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__